var map = {
	"./BUG.png": 97834,
	"./DARK.png": 89774,
	"./DRAGON.png": 65171,
	"./ELECTRIC.png": 18775,
	"./FIGHTING.png": 32952,
	"./FIRE.png": 96138,
	"./FLYING.png": 87007,
	"./GHOST.png": 60445,
	"./GRASS.png": 37850,
	"./GROUND.png": 84499,
	"./ICE.png": 34725,
	"./NORMAL.png": 58899,
	"./POISON.png": 46618,
	"./PSYCHIC.png": 29169,
	"./ROCK.png": 63913,
	"./STEEL.png": 32289,
	"./ULTIMATE.png": 67707,
	"./WATER.png": 89441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45397;